import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTractorContinuityReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxDispatcher: ExcludableTextbox;
    excludabletextboxT: ExcludableTextbox;
    sourceTractorContinuity: DataSource;
    switchExceptionsOnly: Switch;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxDriverType: Textbox;
    textboxTractorStatus: Textbox;
}
